import { FC, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Typography } from 'antd';

import { SEARCH_PARAM_TASK_ID } from '../../constants ';
import { useTaskStore } from '../../modules/business-logic/Task';
import { PagesPaths } from '../../router/paths';
import { LoadingData } from '../../components/LoadingData';
import { ErrorLoad } from '../../components/ErrorLoad';
import { TaskCard } from './components/TaskCard';
import { LeftArrowIcon } from '../../components/Icons';
import { assertNever, AppErrorKind, AsyncStatus } from '../../types';

import styles from './styles.module.css';

const { Text } = Typography;

export const TaskView: FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const taskId = searchParams.get(SEARCH_PARAM_TASK_ID);
    const { taskState, getTaskInfo, arrivalDate } = useTaskStore();

    useEffect(() => {
        if (taskId) {
            getTaskInfo(+taskId);
        }
    }, [taskId, getTaskInfo]);

    const renderResult = () => {
        if (!taskId) {
            return (
                <ErrorLoad
                    description={'Данное задание больше недоступно'}
                    actionLabel={'Перейти в задания'}
                    onAction={() => navigate(PagesPaths.ROOT + PagesPaths.TASK_LIST)}
                />
            );
        }

        switch (taskState.status) {
            case AsyncStatus.IDLE:
            case AsyncStatus.LOADING:
                return null;
            case AsyncStatus.ERROR:
                return taskState.error.kind === AppErrorKind.NOT_FOUND ? (
                    <ErrorLoad
                        description={'Данное задание больше недоступно'}
                        actionLabel={'Перейти в задания'}
                        onAction={() => navigate(PagesPaths.ROOT + PagesPaths.TASK_LIST)}
                    />
                ) : (
                    <ErrorLoad
                        title={'Не удалось загрузить данные'}
                        description={'Проверьте подключение к интернету и попробуйте обновить страницу'}
                        actionLabel={'Обновить страницу'}
                        onAction={() => {
                            if (taskId) getTaskInfo(+taskId);
                        }}
                    />
                );
            case AsyncStatus.SUCCESS:
                return (
                    <div className={styles.card}>
                        <div className={styles.cardContent}>
                            <TaskCard
                                taskId={taskId}
                                name={taskState.data.name}
                                statusData={taskState.data.statusData}
                                dateTime={arrivalDate?.dateTime}
                                timezone={arrivalDate?.timezone}
                            />
                        </div>
                    </div>
                );
            default:
                return assertNever(taskState);
        }
    };

    return (
        <LoadingData
            isLoading={taskState.status === AsyncStatus.LOADING}
            spinnerContentStyles={styles.loaderContainer}
        >
            <div className={styles.task}>
                <Link to={PagesPaths.ROOT + PagesPaths.TASK_LIST} className={styles.backLink}>
                    <LeftArrowIcon />
                    <Text className={styles.backLinkText}>Задания</Text>
                </Link>
                {renderResult()}
            </div>
        </LoadingData>
    );
};
